import { render, staticRenderFns } from "./WebLinkCarousel.vue?vue&type=template&id=30b62c14&scoped=true&"
import script from "./WebLinkCarousel.vue?vue&type=script&lang=js&"
export * from "./WebLinkCarousel.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkCarousel.vue?vue&type=style&index=0&id=30b62c14&scoped=true&lang=scss&"
import style1 from "./WebLinkCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b62c14",
  null
  
)

export default component.exports
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCarousel,QBtn,QCarouselSlide});
